/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Feedback_Filter_NegativeInputs */



/**
* | output |
* | --- |
* | "Negative only" |
*
* @param {Feedback_Filter_NegativeInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const feedback_filter_negative = /** @type {((inputs?: Feedback_Filter_NegativeInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Feedback_Filter_NegativeInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Nur negativ")
	return /** @type {LocalizedString} */ ("Negative only")
});